import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHomeLgAlt } from '@fortawesome/pro-regular-svg-icons/faHomeLgAlt'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { Link } from 'react-router-dom'

import StixBreadcrumb from '@softwaredev_cegeka/stix-core/dist/components/Breadcrumb'

import { reverse } from 'src/routes/config'
import withUserData from 'src/HOCs/withUserData'
import { PageHeaderContext } from 'src/components/PageHeader/pageHeaderContext'

import styles from './breadcrumb.module.scss'

const Breadcrumb = () => {
    const pageHeaderContext = useContext(PageHeaderContext)

    const { breadcrumbs } = pageHeaderContext

    return (
        <StixBreadcrumb
            separator={<FontAwesomeIcon icon={faChevronRight} />}
            className={styles.breadcrumb}
        >
            <StixBreadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                <FontAwesomeIcon icon={faHomeLgAlt} />
            </StixBreadcrumb.Item>
            {breadcrumbs.map((item, index) => {
                const { linkName, label, params, queryParams, hash } = item
                let breadCrumbProps = {
                    // Render the item as in active by marking it as the active breadcrumb item.
                    active: true,
                }
                if (linkName) {
                    breadCrumbProps = {
                        active: index === breadcrumbs.length - 1,
                        linkAs: Link,
                        linkProps: {
                            to: reverse(linkName, params, queryParams, hash),
                        },
                    }
                }
                return (
                    <StixBreadcrumb.Item key={index} {...breadCrumbProps}>
                        {label}
                    </StixBreadcrumb.Item>
                )
            })}
        </StixBreadcrumb>
    )
}

export default withUserData(Breadcrumb)
